import React from 'react'
import { connect } from 'react-redux'

import TopBar from '../../components/Interaction/TopBar'
import {
  setSeverity,
  closeTicket,
  sendFeedback,
  sendDisagreement,
  changeSeverity,
  reopenTicket
} from '../../ducks/interaction'

const TopBarContainer = ({
  interaction,
  ui,
  changeSeverity,
  closeTicket,
  sendFeedback,
  sendDisagreement,
  reopenTicket
}) => {
  const { severity, data, forceDisableCloseButton } = interaction
  const { feedback_required, state } = data

  const { width } = ui.sizes.app
  const showBackButton = width < 992

  return (
    <TopBar
      severity={severity}
      showBackButton={showBackButton}
      state={state}
      feedback={feedback_required}
      changeSeverity={changeSeverity}
      closeTicket={closeTicket}
      sendFeedback={sendFeedback}
      sendDisagreement={sendDisagreement}
      reopenTicket={reopenTicket}
      forceDisableCloseButton={forceDisableCloseButton}
    />
  )
}

export default connect(
  ({ interaction, ui }) => ({ interaction, ui }),
  {
    setSeverity,
    reopenTicket,
    closeTicket,
    sendFeedback,
    sendDisagreement,
    changeSeverity
  }
)(TopBarContainer)
